import PropTypes from 'prop-types';
import styled from 'styled-components';

import TwoColumnLayout from '~/components/TwoColumnLayout';
import { colors, spacing } from '~/utils/css-mixins';
import media from '~/utils/media';
import { authorPropType } from '~/utils/prop-types';

import Byline from './Byline';

const Root = styled.footer`
  margin-top: 2rem;
`;

const Disclaimer = styled.div`
  background-color: #f8f7f5;
  border: dashed 1px ${colors.border};
  padding: ${spacing.siteGutter}px;
  color: #333;
  font-size: 14px;
  font-weight: 400;
  font-style: italic;
  line-height: 1.5714;

  ${media.max('xs')`
    text-align: center;
  `}
`;

const Footer = ({ author, pubDate, disclaimer, showAuthor, comments }) =>
  (showAuthor && author != null) || disclaimer != null ? (
    <Root>
      <TwoColumnLayout>
        {showAuthor && author != null && (
          <Byline author={author} pubDate={pubDate} variant="footer" />
        )}
        {disclaimer != null && <Disclaimer>{disclaimer}</Disclaimer>}
        {comments}
      </TwoColumnLayout>
    </Root>
  ) : null;

Footer.propTypes = {
  author: authorPropType,
  pubDate: PropTypes.string.isRequired,
  disclaimer: PropTypes.string,
  showAuthor: PropTypes.bool.isRequired,
};

export default Footer;
